import { useState } from 'react';
import styles from './ContactPage.module.css';
import { sendEmail } from '../../backend/CloudFunctionsCalls';
import Loading from '../../components/LoadingScreen/Loading';

type Information = {
  name: string;
  email: string;
  message: string;
};

enum FinishedStates {
  'UNSTARTED',
  'SUCCESS',
  'ERROR',
}

const ContactPage = (): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const [finished, setFinished] = useState<FinishedStates>(
    FinishedStates.UNSTARTED,
  );
  const [information, setInformation] = useState<Information>({
    name: '',
    email: '',
    message: '',
  });
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (!loading) {
      setLoading(true);
      await sendEmail(information.email, information.name, information.message)
        .then(() => {
          setFinished(FinishedStates.SUCCESS);
          window.scroll(0, 0);
        })
        .catch(() => {
          setFinished(FinishedStates.ERROR);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.title}>Contact Us</div>
      {finished == FinishedStates.SUCCESS ? (
        <div className={styles.successMessage}>
          Thank you for reaching out. We will get back to you as soon as
          possible.
        </div>
      ) : (
        <form className={styles.form} onSubmit={(event) => handleSubmit(event)}>
          <p className={styles.errorMessage}>
            {finished == FinishedStates.ERROR
              ? 'An error occurred while trying to submit the form.'
              : ''}
          </p>
          <label className={styles.labels}>Name</label>
          <input
            type="text"
            className={styles.inputs}
            placeholder="Enter a name"
            value={information.name}
            onChange={(event) => {
              setInformation({ ...information, name: event.target.value });
            }}
            required
          />
          <label className={styles.labels}>Email</label>
          <input
            type="email"
            className={styles.inputs}
            placeholder="Enter an email address"
            value={information.email}
            onChange={(event) => {
              setInformation({ ...information, email: event.target.value });
            }}
            required
          />
          <label className={styles.labels}>Message</label>
          <textarea
            placeholder="Enter a message"
            className={styles.messageArea}
            value={information.message}
            onChange={(event) => {
              setInformation({ ...information, message: event.target.value });
            }}
            required
          />
          <button type="submit" className={styles.submitButton}>
            {loading ? <Loading /> : 'Submit'}
          </button>
        </form>
      )}
    </div>
  );
};

export default ContactPage;
